import React from 'react';
import ReactDOM from 'react-dom';
import MembersActionCreators from '../../actions/MembersActionCreators.js';
import DropdownMenu from '../misc/DropdownMenu.react';
import DropdownMenuItem from '../misc/DropdownMenuItem.react';
import popup from '../../../app/popup.js';
import modal from '../../../app/modal.js';
import get from 'lodash/get';

class ActivityItemActionBlock extends React.Component {
	static defaultProps = {
	  member_id: null,
	  member_blocked: null,
	  member_ignored: null,
	};

	state = {
	  member_blocked: this.props.member_blocked,
	  member_ignored: this.props.member_ignored,
	};

	render() {
	  const self = this;

	  let blockItemTitle = get(translations, 'txt: Bloķēt šo lietotāju', '');
	  // ja ir bloķēts, rāda atbloķēšanas tekstu
	  if (this.state.member_blocked) {
	    blockItemTitle = get(translations, 'txt: Atbloķēt šo lietotāju', '');
	  }

	  let blockItemIgnoredTitle = get(translations, 'txt: Nerādīt meklētājā', '');
	  // ja ir ignorēts, rāda atbloķēšanas tekstu
	  if (this.state.member_ignored) {
	    blockItemIgnoredTitle = get(translations, 'txt: Rādīt meklētājā', '');
	  }

	  return (
  <DropdownMenu>
    <DropdownMenuItem title={get(translations, 'txt: Ziņot par pārkāpumu', '')} onClickItem={self._onClickReport} />
    <DropdownMenuItem title={blockItemTitle} onClickItem={self._onClickBlockAction} />
    <DropdownMenuItem title={blockItemIgnoredTitle} onClickItem={self._onClickIgnore} />
  </DropdownMenu>
	  );
	}

	/**
	* Handler for 'onClickReport'
	*/
	_onClickReport = (event) => {
	  // event.preventDefault();
	  popup.reportMember(this.props.member_id);
	};

	/**
	* Handler for 'onClickBlockAction'
	*/
	_onClickBlockAction = () => {
	  const msg = get(translations, 'txt: Vai esi pārliecināts?', '');
	  const member_id = this.props.member_id;
	  const member_blocked = this.state.member_blocked;
	  const self = this;

	  const callback = function (result) {
	    if (result) {
	      // atbloķēt
	      if (member_blocked) {
	        MembersActionCreators.unblock(member_id);
	        self.setState({ member_blocked: false });
	      }
	      // bloķēt
	      else {
	        MembersActionCreators.block(member_id);
	        self.setState({ member_blocked: true });
	      }
	    }
	  };

	  modal.confirm(msg, callback);
	};

	_onClickIgnore = () => {
	  const msg = get(translations, 'txt: Vai esi pārliecināts?', '');
	  const member_id = this.props.member_id;
	  const member_ignored = this.state.member_ignored;
	  const self = this;

	  const callback = function (result) {
	    if (result) {
	      if (member_ignored) {
	        MembersActionCreators.unignore(member_id);
	        self.setState({ member_ignored: false });
	      } else {
	        MembersActionCreators.ignore(member_id);
	        self.setState({ member_ignored: true });
	      }
	    }
	  };

	  modal.confirm(msg, callback);
	};
}

module.exports = ActivityItemActionBlock;
